// SingaporePhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const SingaporePhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in Singapore</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Degree:</strong> Doctor of Philosophy (PhD)
            </li>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>A relevant Bachelor’s (Honours) or Master’s degree</li>
                <li>Strong academic record and research proposal</li>
                <li>English proficiency: TOEFL/IELTS (if required)</li>
              </ul>
            </li>
            <li>
              <strong>Admission Requirements:</strong>
              <ul>
                <li>Online application + Statement of Purpose (SOP)</li>
                <li>Academic transcripts, recommendation letters</li>
                <li>May require an entrance exam or interview</li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>Fully funded PhD scholarships are common</li>
                <li>Monthly stipend: SGD 2,000–3,500/month</li>
                <li>
                  Scholarships include SINGA, University Research Scholarships
                  (NUS, NTU, SMU, SUTD)
                </li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Position:</strong> Research Fellow / Research Scientist
            </li>
            <li>
              <strong>Duration:</strong> 1 to 3 years (renewable)
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Completed PhD in a relevant discipline</li>
                <li>Strong publication record (Q1/Q2 journals preferred)</li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Salary: SGD 4,000–8,000/month (varies by experience and
                  project)
                </li>
                <li>
                  Usually funded through university grants or national research
                  programs
                </li>
              </ul>
            </li>
            <li>
              <strong>Focus Areas:</strong> Biomedical sciences, AI,
              Engineering, Clean Energy, Public Health, Finance, Social Sciences
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Singapore</h2>
          <ol>
            <li>
              <strong>National University of Singapore (NUS)</strong>
              <p>
                Singapore’s #1 and globally top-ranked. Strong research in
                engineering, science, life sciences, public policy, and
                business. Offers SINGA and internal scholarships.
              </p>
            </li>
            <li>
              <strong>Nanyang Technological University (NTU)</strong>
              <p>
                Ranked among the world’s top universities. Leading in AI,
                sustainability, materials science, and business research. Host
                institution for many SINGA scholars.
              </p>
            </li>
            <li>
              <strong>Singapore Management University (SMU)</strong>
              <p>
                Top-tier for PhD in social sciences, law, economics, and
                business. Research-intensive with good international tie-ups.
              </p>
            </li>
            <li>
              <strong>
                Singapore University of Technology and Design (SUTD)
              </strong>
              <p>
                Specializes in design, innovation, engineering, and technology.
                Collaboration with MIT; offers research-intensive PhD programs.
              </p>
            </li>
            <li>
              <strong>Duke-NUS Medical School (Duke-NUS)</strong>
              <p>
                Joint venture between Duke University (USA) and NUS. Ideal for
                PhD and postdoc in biomedical sciences and clinical research.
              </p>
            </li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default SingaporePhD;
